<template>
  <svg
    width="28"
    height="20"
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 4458">
      <rect
        id="Rectangle 301"
        x="0.5"
        y="1"
        width="7"
        height="7"
        rx="0.5"
        stroke="#110F13"
      />
      <rect
        id="Rectangle 302"
        x="10.5"
        y="1"
        width="7"
        height="7"
        rx="0.5"
        stroke="#110F13"
      />
      <rect
        id="Rectangle 303"
        x="20.5"
        y="1"
        width="7"
        height="7"
        rx="0.5"
        stroke="#110F13"
      />
      <rect
        id="Rectangle 304"
        x="20.5"
        y="12"
        width="7"
        height="7"
        rx="0.5"
        stroke="#110F13"
      />
      <rect
        id="Rectangle 305"
        x="10.5"
        y="12"
        width="7"
        height="7"
        rx="0.5"
        stroke="#110F13"
      />
      <rect
        id="Rectangle 306"
        x="0.5"
        y="12"
        width="7"
        height="7"
        rx="0.5"
        stroke="#110F13"
      />
    </g>
  </svg>
</template>
